import { observer } from 'mobx-react-lite';

import { IcBackIcon, IcDoneIcon } from '@gem/icons';
import { AddKeyPressHandler } from '@gem/keyboard-handler';
import { useTranslation } from '@gem/modules/i18n';

import Border from '../components/Border';
import Button from '../components/Button';
import usePresenter from './presenter';
import styles from './styles.m.scss';

const EnterLink = ({ onBackClick, onAddLink }) => {
  const { t } = useTranslation();

  const { inputRef, presenter } = usePresenter({ onAddLink, onBackClick });

  return (
    <>
      <Button
        iconClassName={styles.back}
        Icon={IcBackIcon}
        onClick={presenter.onBackClick}
      />
      <input
        value={presenter.value}
        onChange={presenter.onChange}
        ref={inputRef}
        className={styles.input}
        placeholder={t('paste_or_type')}
      />
      <Border />
      <Button
        theme="primary"
        isDisabled={presenter.isDisabledSubmit}
        Icon={IcDoneIcon}
        onClick={presenter.onDone}
      />
      <AddKeyPressHandler
        isCaptured
        onEnter={presenter.onEnter}
      />
    </>
  );
};

export default observer(EnterLink);
